import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { paymentInfo } from '@/mocks/applicationData';

export default function PaymentInfo() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-14">
          <p className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
            {t('application.payment.label')}
          </p>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {lang === 'en' ? t('application.payment.title') : paymentInfo.title}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {paymentInfo.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {lang === 'en' ? t('application.payment.lead') : paymentInfo.lead}
          </p>
        </div>

        <div className="border border-background-200/60 bg-background-50">
          {paymentInfo.items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-start gap-5 px-6 py-5 ${
                idx < paymentInfo.items.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500/10 flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-accent-600 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-[13px] text-foreground-400 tracking-[0.08em] font-label mb-1">
                  {lang === 'en' ? t(`application.payment.item.${idx}.label`) : item.label}
                </p>
                <p className="text-[16px] text-foreground-800 tracking-[0.04em] leading-relaxed">
                  {lang === 'en' ? t(`application.payment.item.${idx}.value`) : item.value}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 p-5 border border-accent-500/20 bg-accent-500/[0.03] text-center">
          <p className="text-[15px] text-foreground-700 tracking-[0.04em] leading-relaxed">
            {t('application.payment.bankOnlyNote')}
          </p>
        </div>
      </div>
    </section>
  );
}
